import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const installAttributionSourceSchema = z.object({
  kind: z.enum(["meta_ad", "google_ad", "paid_other", "partner"]),
  label: z.string(),
});

export const getTeamSignupAttribution = {
  name: "getTeamSignupAttribution" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ sources: z.array(installAttributionSourceSchema) }),
};
